<script lang="ts">
  export interface SearchResultHeaderProps {
    /** The number of search results found */
    searchResultsCount?: number
    /** The text to display on the right side of the search result header */
    textRight?: string
    /** The title of the search result header */
    title?: string
  }
</script>

<script setup lang="ts">
  const props = withDefaults(defineProps<SearchResultHeaderProps>(), {
    title: 'Search results'
  })
</script>
<template>
  <div
    class="flex items-center gap-2 border-b bg-gray-50 px-4 py-2 text-xs font-medium"
  >
    <div class="text-xs font-medium">{{ title }}</div>
    <div v-if="props.searchResultsCount" class="ml-auto text-xs text-gray-500">
      {{ props.searchResultsCount }}
      {{ 'result'.gs_toPlural(props.searchResultsCount, 's') }}
    </div>
    <div v-if="props.textRight" class="ml-auto text-xs text-gray-500">
      {{ props.textRight }}
    </div>
  </div>
</template>
